import styled from "styled-components";
import {colors} from "../../utils/styled/_variables.styled";

const ContentType = styled.div`
  display: flex;
  font-weight: 600;
  line-height: 120%;
  font-size: 10px;
  margin-bottom: 8px;
  p {
    margin-top: unset !important;
    margin-right: 8px;
    color: ${colors.gray5};
  }
`;

export { ContentType };
